<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="true"
    :breadcrumb="getBreadcrumb">
    <div slot="custom-controls-top">
      <div class="controls__filters note">
        <grid-row col-spaced>
          <grid-col col-size="3">
            <health-explorer-controls
              class="margin-right-xxl"
              v-model="selectedDay"
              v-on:input="requestDataInEmit"
              v-on:inputFilter="filterChanged"
              :filters="getFilterOptions"
              :filterValue="getFilterOptions[0]"
            />
          </grid-col>

          <grid-col col-size="2">
            <health-explorer-controls-user-select
              v-model="selectedUser"
              v-on:click="requestData"
              :filterPremium="true"
              v-show="!disableUserSelect"
              v-on:hidden="hiddeComp"
            />
          </grid-col>
        </grid-row>
      </div>
    </div>
    <div class="container">
      <div class="header">
        <div class="header__title">
          <h1
            class="flex">
            {{ $t('health.summary.title') }}
          </h1>
        </div>
      </div>
      <div v-if="!accessDenied">
        <grid-row class="">
          <grid-col col-size="2">
            <h3 class="chart-title">
              {{ $t('health.summary.averageMacros') }}
            </h3>
            <macro-average-chart :kcals="avgKcals" :carbs="avgCarbs" :protein="avgProtein" :fat="avgFat"/>
          </grid-col>
          <grid-col col-size="1"/>
          <grid-col col-size="2" v-if="weight">
            <h3 class="chart-title">
              {{ $t('health.summary.averageMacrosKilo') }}
            </h3>
            <weight-macro-chart :kcalsKilo="avgKcalsKilo" :carbsKilo="avgCarbsKilo" :proteinKilo="avgProteinKilo"
                                :fatKilo="avgFatKilo"/>
          </grid-col>
        </grid-row>
        <grid-row class="" column-align="center">
          <grid-col col-size="1">
            <btn-pill
              class="update-button"
              :btnText="$t('health.summary.button')"
              v-on:click="viewDetails">
            </btn-pill>
          </grid-col>
        </grid-row>
        <div v-show="visible">
          <div class="flex flex-direction-variable margin-top-xxl">
            <div class="max-width">

              <h3 class="chart-title">
                {{ $t('health.summary.glucoscore') }}
                <div @click="showGlucoScoreModal" >
                  <font-awesome-icon class="margin-left-m" :icon="icons.question"/>
                </div>
              </h3>
              <glucoscore-chart :glucoscore="glucoscore"/>
            </div>
            <div class="max-width">
              <h3 class="chart-title">
                {{ $t('health.summary.vibeBattery') }}
                <div @click="showVibeBatteryModal">
                  <font-awesome-icon class="margin-left-m" :icon="icons.question"/>
                </div>
              </h3>
              <vibe-battery-chart :vibeBattery="vibeBattery"/>
            </div>
          </div>
        </div>
        <div v-show="!visible">
          <grid-row class="margin-top-xl margin-bottom-xl" column-align="center">
            <grid-col col-size="4">
              <div v-show="weight">
                <weight-summary-table :data="chartData" v-on:selected="selectedData"/>
              </div>
              <div v-show="!weight">
                <summary-table :data="chartData" v-on:selected="selectedData"/>
              </div>
            </grid-col>
          </grid-row>
        </div>
      </div>
      <div v-else>
        Access denied
      </div>
    </div>

    <information-modal
      v-if="showInformationModal"
      v-on:accept="closeInformationModal"
      :title="informationTitle"
      :htmlContent="informationMessage"
      :knowMoreLink="knowMoreLink"
    >
    </information-modal>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import HealthChart from 'BRAND/components/explorer/HealthChart';
import api from 'BRAND/api/summary';
import HealthExplorerControls from 'BRAND/components/explorer/HealthExplorerControls';
import HealthExplorerControlsUserSelect from 'BRAND/components/explorer/HealthExplorerControlsUserSelect';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import SummaryTable from 'BRAND/components/summary/SummaryTable';
import WeightSummaryTable from 'BRAND/components/summary/WeightSummaryTable';
import WeightMacroChart from 'BRAND/components/summary/WeightMacroChart';
import MacroAverageChart from 'BRAND/components/summary/MacroAverageChart';
import VibeBatteryChart from 'BRAND/components/summary/VibeBatteryChart';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import BtnPill from '@/components/shared/buttons/BtnPill';
import GlucoscoreChart from 'BRAND/components/summary/GlucoscoreChart';
import faQuestionCircle from '@fortawesome/fontawesome-free-solid/faQuestionCircle';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import InformationModal from '@/components/shared/dialogs/InformationModal';

export default {
  name: 'HealthSummary',
  components: {
    GlucoscoreChart,
    BtnPill,
    WeightSummaryTable,
    WeightMacroChart,
    SummaryTable,
    MainLayout,
    HealthExplorerControls,
    HealthChart,
    HealthExplorerControlsUserSelect,
    TableComponent,
    TableColumn,
    GridCol,
    GridRow,
    MacroAverageChart,
    VibeBatteryChart,
    FontAwesomeIcon,
    InformationModal
  },
  data () {
    return {
      /* Modals */
      showInformationModal: false,
      informationTitle: '',
      informationMessage: '',
      knowMoreLink: null,
      disableUserSelect: false,
      selectedDay: new Date(),
      selectedUser: null,
      selectedFilter: {label: '', id: 1},
      chartData: null,
      filteredData: null,
      kcalsKilo: null,
      proteinKilo: null,
      carbsKilo: null,
      fatKilo: null,

      avgKcals: null,
      avgProtein: null,
      avgCarbs: null,
      avgFat: null,

      avgKcalsKilo: null,
      avgProteinKilo: null,
      avgCarbsKilo: null,
      avgFatKilo: null,
      weight: null,
      visible: true,
      vibeBattery: [],
      glucoscore: [],
      icons: {
        question: faQuestionCircle
      },
      accessDenied: false
    };
  },
  watch: {
    selectedDay: {
      handler: function () {
        this.requestData();
      }
    },
    selectedUser: {
      handler: function () {
        this.requestData();
      }
    },
    selectedFilter: {
      handler: function () {
        this.requestData();
      }
    }
  },
  mounted () {
    this.requestData();
  },
  computed: {
    getBreadcrumb () {
      return [{name: this.$t('health.explorer.title'), disabled: true}];
    },
    getFilterOptions () {
      let reObj = [{label: this.$t('health.explorer.controls'), id: 1},
        {label: this.$t('health.explorer.controlsDay'), id: 2},
        {label: this.$t('health.explorer.controls14'), id: 3},
        {label: this.$t('health.explorer.controls30'), id: 4}
      ];
      return reObj;
    }
  },
  methods: {
    resetDefaultValues () {
      this.weight = null;
      this.vibeBattery = [];
      this.chartData = [];
      this.glucoscore = [];
    },
    viewDetails () {
      this.visible = !this.visible;
    },
    requestData () {
      let fromDay;
      let numDays;
      this.selectedDay.setUTCHours(0, 0, 0, 0);
      fromDay = this.selectedDay.getTime();
      // 100 milliseconds of dealy to prevent date selector's UI freezing
      setTimeout(() => {
        if (this.selectedFilter.id === 1) {
          // Week view, last 7 days
          fromDay = fromDay - (6 * 24 * 60 * 60 * 1000);
          numDays = 7;
        } else if (this.selectedFilter.id === 2) {
          numDays = 1;
        } else if (this.selectedFilter.id === 3) {
          // Week view, last 14 days
          fromDay = fromDay - (13 * 24 * 60 * 60 * 1000);
          numDays = 14;
        } else if (this.selectedFilter.id === 4) {
          // Week view, last 30 days
          fromDay = fromDay - (29 * 24 * 60 * 60 * 1000);
          numDays = 30;
        }

        api.getSummary(this, fromDay, numDays, this.selectedUser)
          .then(data => {
            this.accessDenied = false;
            this.resetDefaultValues();
            data.items.map((item) => {
              if (data.weight && data.weight > 0) {
                item.carbsWeight = Math.round((item.carbs / data.weight) * 100) / 100;
                item.caloriesWeight = Math.round((item.calories / data.weight) * 100) / 100;
                item.fatWeight = Math.round((item.fat / data.weight) * 100) / 100;
                item.proteinWeight = Math.round((item.protein / data.weight) * 100) / 100;

                this.kcalsKilo = item.caloriesWeight;
                this.carbsKilo = item.carbsWeight;
                this.fatKilo = item.fatWeight;
                this.proteinKilo = item.proteinWeight;
              }
              this.glucoscore = data.glucoscoreItemList;
              if (item.timestamp) {
                this.vibeBattery.push({
                  timestamp: item.timestamp,
                  value: item.vibeBattery
                });
              }
              return item;
            });

            this.avgCarbs = data.average.carbs;
            this.avgKcals = data.average.calories;
            this.avgFat = data.average.fat;
            this.avgProtein = data.average.protein;

            if (data.weight && data.weight > 0) {
              this.weight = data.weight;
              this.avgCarbsKilo = Math.round((this.avgCarbs / data.weight) * 100) / 100;
              this.avgKcalsKilo = Math.round((this.avgKcals / data.weight) * 100) / 100;
              this.avgFatKilo = Math.round((this.avgFat / data.weight) * 100) / 100;
              this.avgProteinKilo = Math.round((this.avgProtein / data.weight) * 100) / 100;
            }

            this.chartData = data.items;
          })
          .catch(error => {
            if (error.data && error.status === 500 && error.data.message.includes('access to premium features')) {
              this.accessDenied = true;
            }
            if (error.data && error.status === 403 && error.data && error.data.message.includes('Access is denied')) {
              this.accessDenied = true;
            }
          });
      }, 100);
    },
    getSelectedFilter () {
      return this.getFilterOptions[0];
    },

    hiddeComp () {
      this.disableUserSelect = !this.disableUserSelect;
    },
    requestDataInEmit () {
      if (this.disableUserSelect) {
        this.requestData();
      }
    },
    selectedData (filteredData) {
      this.avgCarbs = filteredData.avgCarbs;
      this.avgKcals = filteredData.avgKcals;
      this.avgFat = filteredData.avgFat;
      this.avgProtein = filteredData.avgProtein;
      this.avgCarbsKilo = Math.round((this.avgCarbs / this.weight) * 100) / 100;
      this.avgKcalsKilo = Math.round((this.avgKcals / this.weight) * 100) / 100;
      this.avgFatKilo = Math.round((this.avgFat / this.weight) * 100) / 100;
      this.avgProteinKilo = Math.round((this.avgProtein / this.weight) * 100) / 100;

      if (filteredData.filteredData.length === 0) {
        this.avgCarbsKilo = 0;
        this.avgKcalsKilo = 0;
        this.avgFatKilo = 0;
        this.avgProteinKilo = 0;
      }
    },
    filterChanged (selectValue) {
      this.selectedFilter = selectValue;
      this.requestDataInEmit();
    },
    timeFormatter (timestamp) {
      if (timestamp === null) return this.$t('health.summary.average');
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('en-GB');
    },

    showVibeBatteryModal () {
      this.showInformationModal = true;
      this.informationTitle = this.$t('health.summary.vibeBattery');
      this.informationMessage = this.$t('health.summary.vibeBatteryInfo');
      this.knowMoreLink = 'http://tiny.cc/blog-vibebattery';
    },
    showGlucoScoreModal () {
      this.showInformationModal = true;
      this.informationTitle = this.$t('health.summary.glucoscore');
      this.informationMessage = this.$t('health.summary.glucoscoreInfo');
      this.knowMoreLink = 'http://tiny.cc/blog-glucoscore';
    },
    closeInformationModal () {
      this.showInformationModal = false;
      this.informationTitle = '';
      this.informationMessage = '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.container {
  padding-top: $sp-margin;
  padding-bottom: $sp-margin;
  flex-grow: 1;
  min-height: 100%;
  @supports (-webkit-touch-callout: none) {
    display: -ms-flexbox;
  }
  @supports not (-webkit-touch-callout: none) {
    display: flex;
  }
  flex-direction: column;
}

.chart-title {
  display: flex;
  font-size: 1.2rem;
  margin-bottom: $sp-margin-small;
  text-align: center;
  align-items: center
}

.update-button {
  font-size: 1rem;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;

  &__title {
    margin-bottom: $sp-margin;
    @media (min-width: $breakpoint) {
      display: flex;
      h1 {
        margin-bottom: 0;
        margin-right: $sp-margin;
        padding-right: $sp-margin;
      }
    }
  }
}

.flex-column {
  flex-direction: column;
}

.flex-direction-variable {
  flex-direction: column;
  @media (min-width: $screen-wide) {
    flex-direction: row;
  }
}

.max-width {
  width: 100%;
}

.hide-on-desktop {
  @media only screen and (hover: hover) and (pointer: fine) {
    display: none;
  }
}

.hide-on-phone {
  @media only screen and (hover: none) and (pointer: coarse) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/HealthSummary.vue